module.exports = __webpack_public_path__ + "img/49.35a5e21b.jpg";